export const jsonToURI = (input) => {
    if (typeof input === 'string') {
        return encodeURIComponent(input);
    }
    return encodeURIComponent(JSON.stringify(input));
};
export const uriToJSON = (input) => {
    const decodedValue = decodeURIComponent(input);
    try {
        return JSON.parse(decodedValue);
    }
    catch (e) {
        // Not a JSON object, already a string
        return decodedValue;
    }
};
export const jsonToBase64 = (input) => {
    return btoa(jsonToURI(input).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
        return String.fromCharCode(`0x${p1}`);
    }));
};
export const base64ToJSON = (input) => {
    return uriToJSON(atob(input)
        .split('')
        .map((c) => {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
    })
        .join(''));
};
//# sourceMappingURL=urlEncoding.js.map